import React from 'react';
import { Box, Container, Tabs, Tab } from '@mui/material';
import { Business as BusinessIcon, Dashboard as DashboardIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import ClientProfile from './ClientProfile';
import { CssBaseline, ThemeProvider } from '@mui/material';
import salesTheme from '../../theme/salesTheme';

const SalesProfilePage = () => {
  const navigate = useNavigate();

  return (
    <ThemeProvider theme={salesTheme}>
    <CssBaseline />
    <Box sx={{ flexGrow: 1, minHeight: '100dvh' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
        <Container maxWidth="xl">
          <Tabs
            value={0}
            onChange={(e, newValue) => {
              if (newValue === 1) navigate('/dashboard');
              else navigate('/sales');
            }}
            sx={{ '& .MuiTab-root': { textTransform: 'none', fontSize: '1rem', fontWeight: 500, minWidth: 120 } }}
          >
            <Tab label="Sales" icon={<BusinessIcon />} iconPosition="start" />
            <Tab label="Admin Dashboard" icon={<DashboardIcon />} iconPosition="start" />
          </Tabs>
        </Container>
      </Box>
      <Container maxWidth="xl" sx={{ mt: { xs: 1, sm: 4 }, mb: 4, px: { xs: 0.5, sm: 3 } }}>
        <ClientProfile />
      </Container>
    </Box>
    </ThemeProvider>
  );
};

export default SalesProfilePage;
